// @flow
import {combineReducers} from 'redux';
import {i18nReducer, MODULE_NAME as I18N_MODULE_NAME} from 'us-i18n';
import {mapModuleReducer} from 'modules/map/reducers';
import {EXERCISE_MODULE_NAME} from 'modules/exercise/constants';
import {exerciseModuleReducer} from 'modules/exercise/reducers';
import {gameModuleReducer} from 'modules/game/reducers';
import {gameVarsModuleReducer} from 'modules/game-vars/reducers';
import {GAME_MODULE_NAME} from 'modules/game/constants';
import {
    slideModule,
    scenarioModule,
    timerModule,
    centrifugeModule,
    modalModule,
    exerciseGameModule,
    zoneModule,
    gameVarsModule,
    mapModule,
} from 'us-csg-game-common';
import {BET_MODULE_NAME} from 'modules/bet/constants';
import {betModuleReducer} from 'modules/bet/reducers';
import {CONSOLE_MODULE_NAME} from 'modules/console/constants';
import {consoleModuleReducer} from 'modules/console/reducers';
import {TEXT_INPUT_BLOCK_MODULE_NAME} from 'modules/text-input-block/constants';
import {textInputBlockModuleReducer} from 'modules/text-input-block/reducers';

import {RATE_BLOCK_MODULE_NAME} from 'modules/rate-block/constants';
import {rateBlockModuleReducer} from 'modules/rate-block/reducers';

import {VOTE_BLOCK_MODULE_NAME} from 'modules/vote-block/constants';
import {voteBlockModuleReducer} from 'modules/vote-block/reducers';

import {YES_NO_BLOCK_MODULE_NAME} from 'modules/yes-no-block/constants';
import {yesNoBlockModuleReducer} from 'modules/yes-no-block/reducers';

import {POLL_MODULE_NAME} from 'modules/poll/constants';
import {pollModuleReducer} from 'modules/poll/reducers';
import {CERTIFICATE_MODULE_NAME} from 'modules/certificate/constants';
import {certificateModuleReducer} from 'modules/certificate/reducers';
import {AUTH_MODULE_NAME} from 'modules/auth/constants';
import {authModuleReducer} from 'modules/auth/reducers';
import {MASTER_CENTRIFUGE_MODULE_NAME} from 'modules/centrifuge/constants';
import {MasterCentrifugeReducer} from 'modules/centrifuge/reducers';

import {dialogBlockReducer} from 'modules/dialog-block/reducers/dialog-block';
import {DIALOG_BLOCK_MODULE_NAME} from 'modules/dialog-block/constants';

const reducers = {
    [AUTH_MODULE_NAME]: authModuleReducer,
    [BET_MODULE_NAME]: betModuleReducer,
    [centrifugeModule.CENTRIFUGE_MODULE_NAME]: centrifugeModule.centrifugeModuleReducer,
    [CERTIFICATE_MODULE_NAME]: certificateModuleReducer,
    [CONSOLE_MODULE_NAME]: consoleModuleReducer,
    [DIALOG_BLOCK_MODULE_NAME]: dialogBlockReducer,
    [exerciseGameModule.EXERCISE_GAME_MODULE_NAME]: exerciseGameModule.exerciseGameModuleReducer,
    [EXERCISE_MODULE_NAME]: exerciseModuleReducer,
    [GAME_MODULE_NAME]: gameModuleReducer,
    [gameVarsModule.GAME_VARS_MODULE_NAME]: gameVarsModuleReducer,
    [I18N_MODULE_NAME]: i18nReducer,
    [MASTER_CENTRIFUGE_MODULE_NAME]: MasterCentrifugeReducer,
    [mapModule.MAP_MODULE_NAME]: mapModuleReducer,
    [modalModule.MODAL_MODULE_NAME]: modalModule.modalModuleReducer,
    [POLL_MODULE_NAME]: pollModuleReducer,
    [scenarioModule.SCENARIO_MODULE_NAME]: scenarioModule.scenarioModuleReducer,
    [slideModule.SLIDE_MODULE_NAME]: slideModule.slideModuleReducer,
    [zoneModule.ZONE_MODULE_NAME]: zoneModule.zoneModuleReducer,
    [RATE_BLOCK_MODULE_NAME]: rateBlockModuleReducer,
    [TEXT_INPUT_BLOCK_MODULE_NAME]: textInputBlockModuleReducer,
    [VOTE_BLOCK_MODULE_NAME]: voteBlockModuleReducer,
    [YES_NO_BLOCK_MODULE_NAME]: yesNoBlockModuleReducer,
    [timerModule.TIMER_MODULE_NAME]: timerModule.timerModuleReducer,
};

const rootReducer = combineReducers(reducers);

type TState = typeof reducers;
type TGetState = () => TState;

export {rootReducer};
export type {TState, TGetState};
